import { PanelResizeHandle } from "react-resizable-panels";

export const ResizeHandle = () => (
  <PanelResizeHandle className="flex h-screen flex-col items-center justify-center border-elevation-outline-1 border-x px-1">
    <div className="flex w-full flex-col items-center justify-center gap-0-5">
      <div className="h-0-5 w-0-5 rounded-full bg-text-inverted-secondary" />
      <div className="h-0-5 w-0-5 rounded-full bg-text-inverted-secondary" />
      <div className="h-0-5 w-0-5 rounded-full bg-text-inverted-secondary" />
      <div className="h-0-5 w-0-5 rounded-full bg-text-inverted-secondary" />
    </div>
  </PanelResizeHandle>
);
